import { render } from "./ModalFiltroCategoriasUnidades.vue?vue&type=template&id=bf75edea&scoped=true"
import script from "./ModalFiltroCategoriasUnidades.vue?vue&type=script&lang=js"
export * from "./ModalFiltroCategoriasUnidades.vue?vue&type=script&lang=js"

import "./ModalFiltroCategoriasUnidades.vue?vue&type=style&index=0&id=bf75edea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf75edea"]])

export default __exports__